/**
 * App-menu route guard (spec §5.3). The app build carries the list of route
 * prefixes switched ON for this app+platform; anything else lands on the
 * "Open on the web" screen. `null` = a web build: everything allowed.
 */

/** Routes the shell itself needs — reachable whatever the app menu says. */
export const SHELL_ROUTES: readonly string[] = ['/login', '/logout', '/open-on-web', '/update-required'];

export function normalizePath(path: string): string {
  let p = path.split(/[?#]/)[0] || '/';
  if (!p.startsWith('/')) p = `/${p}`;
  if (p.length > 1) p = p.replace(/\/+$/, '') || '/';
  return p;
}

export function isRouteAllowed(
  path: string,
  allow: readonly string[] | null,
  always: readonly string[] = SHELL_ROUTES,
): boolean {
  if (allow === null) return true;
  const p = normalizePath(path);
  return [...always, ...allow].some((entry) => {
    const a = normalizePath(entry);
    if (a === '/') return p === '/';            // home only, never a wildcard
    return p === a || p.startsWith(`${a}/`);    // exact or a child, never a look-alike
  });
}

/** Where "Open on the web" sends the user. platform-app is a hash router; super-admin-ui is not. */
export function webUrlFor(path: string, webOrigin: string, routing: 'hash' | 'path'): string {
  const origin = webOrigin.replace(/\/+$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return routing === 'hash' ? `${origin}/#${p}` : `${origin}${p}`;
}
